export default {"src":"/_next/static/media/zeilen.dbf35f95.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};